// extracted by mini-css-extract-plugin
export default {"container":"CommentInput-module__container--g4Lj4","animatedBackground":"CommentInput-module__animatedBackground--vis3h"};